module.exports = __webpack_public_path__ + "static/img/badge-trap-active.d835015.svg";